import { render } from "./Login.vue?vue&type=template&id=2fe1f4b4"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=2fe1f4b4&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\program\\Telegram Reminder\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__